module.exports = __webpack_public_path__ + "static/media/10_Mole_studio_03(1).9e9d8d2a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/10_Mole_studio_03(1).mp4
// module id = 223
// module chunks = 0